import Modal from "../../../components/ui/Modal";
import { cx } from "../../../utils/classNames";
import LocationHelp from "./LocationHelp";
import ui from "../../../components/ui/ui.module.css";

const LocationHelpModal = ({ onClose }) => (
  <Modal
    title="How to allow location access"
    onClose={onClose}
    footer={
      <button
        type="button"
        className={cx(ui.button, ui.primary)}
        onClick={onClose}
      >
        Got it
      </button>
    }
  >
    <LocationHelp />
  </Modal>
);

export default LocationHelpModal;
